<template>
  <div>
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="el-icon-s-home"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          {{ getTitle('header.interaction') }}
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          {{ getTitle('header.explain') }}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="map-wrapper">
      <map-guide class="map" @update="handleUpdate"></map-guide>
      <el-dialog
        :visible.sync="modalNav"
        top="40vh"
        :show-close="false"
        width="340px"
      >
        <div class="dialog_content">
          <div class="img_box">
            <img :src="zoom_image" />
          </div>
          <!-- <div class="btns vr" @click="handleVr">VR虚拟游</div> -->
          <div
            v-if="!playing_cn"
            class="btns bobao_cn"
            @click="handlePlayingcn"
          >
            中文讲解
          </div>
          <div v-else id="playing_cn" class="btns" @click="handlePlayingcn">
            <div class="icon">
              <div id="one" class="wave"></div>
              <div id="two" class="wave"></div>
              <div id="three" class="wave"></div>
              <div id="four" class="wave"></div>
              <div id="five" class="wave"></div>
              <div id="six" class="wave"></div>
              <div id="seven" class="wave"></div>
            </div>
            <p>讲解中</p>
          </div>
          <div
            v-if="!playing_en"
            class="btns bobao_en"
            @click="handlePlayingEn"
          >
            English
          </div>
          <div v-else id="playing_en" class="btns" @click="handlePlayingEn">
            <div class="icon">
              <div id="one" class="wave"></div>
              <div id="two" class="wave"></div>
              <div id="three" class="wave"></div>
              <div id="four" class="wave"></div>
              <div id="five" class="wave"></div>
              <div id="six" class="wave"></div>
              <div id="seven" class="wave"></div>
            </div>
            <p>Playing</p>
          </div>
        </div>

        <el-dialog
          class="vr-dialog"
          width="60%"
          :title="vr_title"
          :visible.sync="vrVisible"
          append-to-body
        >
          <img src="@/assets/images/home-02.jpg" style="width: 100%" />
        </el-dialog>
      </el-dialog>

      <audio id="audio" :src="video_url">
        <source :src="video_url" type="audio/mpeg" />
        您的浏览器不支持 audio 元素。
      </audio>
      <audio id="audio_en" :src="video_url_en">
        <source :src="video_url_en" type="audio/mpeg" />
        您的浏览器不支持 audio 元素。
      </audio>
      <!-- <audio id="audio">
        <source :src="video_url" type="audio/mpeg" />
        您的浏览器不支持 audio 元素。
      </audio> -->
    </div>
  </div>
</template>

<script>
import { setLocaleToPath, loadLanguageAsync } from '@/setup/i18n';
import mapGuide from '@/components/map/map';
export default {
  name: 'MapGuide',
  components: { mapGuide },
  data() {
    return {
      modalNav: false,
      vrVisible: false,
      zoom_image: '',
      playing_cn: false,
      playing_en: false,
      video_url: '', //语音播报url
      video_url_en: '', //英语语音播报url
      vr_title: '',
    };
  },
  computed: {
    locale() {
      return this.$store.state.locale;
    },
  },
  mounted() {
    this.$store.dispatch('getGuidelist', {
      merchant_code: process.env.VUE_APP_MERCHANT_CODE,
      status: 'publish',
      page_size: 5000,
    });
  },
  created() {
    this.$store.commit('setLocale', this.$i18n.locale); // 触发指定默认语言
  },
  methods: {
    getTitle(name) {
      loadLanguageAsync(this.locale);
      return this.$t(`${name}.title`);
    },
    handleUpdate(data) {
      if (data.showDialog == true) {
        this.modalNav = true;
        this.zoom_image = data.currentMarker.scenic_icon;
        if (this.vr_title != data.currentMarker.name) {
          this.playing_cn = false;
          this.playing_en = false;
          this.video_url = data.currentMarker.video_url;
          this.video_url_en = data.currentMarker.video_url_en;
        }
        this.vr_title = data.currentMarker.name;
      }
    },
    // 点击语音播报
    handlePlayingcn() {
      let audio = document.getElementById('audio');
      let audio_en = document.getElementById('audio_en');
      if (audio.src) {
        if (audio.paused) {
          this.playing_cn = true;
          this.playing_en = false;
          audio_en.pause(); // 这个就是暂停
          audio.play(); //audio.play();// 这个就是播放
        } else {
          this.playing_cn = false;
          audio.pause(); // 这个就是暂停
        }
      } else {
        this.$message('音频为空！');
      }
    },
    handlePlayingEn() {
      let audio = document.getElementById('audio');
      let audio_en = document.getElementById('audio_en');
      if (audio_en.src) {
        if (audio_en.paused) {
          this.playing_en = true;
          this.playing_cn = false;
          audio.pause(); // 这个就是暂停
          audio_en.play(); //audio.play();// 这个就是播放
        } else {
          this.playing_en = false;
          audio_en.pause(); // 这个就是暂停
        }
      } else {
        this.$message('音频为空！');
      }
    },
    handleVr() {
      this.vrVisible = true;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@keyframes yuying1 {
  0% {
    height: 10%;
  }
  20% {
    height: 50%;
  }
  50% {
    height: 100%;
  }
  80% {
    height: 50%;
  }
  100% {
    height: 0%;
  }
}

.map-wrapper {
  width: 920px;
  height: 680px;
  margin: 0 auto;
}
.map {
  height: 100%;
  // height: ~'-webkit-calc(100vh - 70px)';
  // height: ~'-moz-calc(100vh - 70px)';
  // height: calc(100vh - 70px);
}
/deep/.el-dialog {
  background-color: transparent;
  box-shadow: none;
  .el-dialog__header,
  .el-dialog__body {
    padding: 0;
  }
}
.dialog_content {
  position: relative;
  .img_box {
    width: 120px;
    height: 120px;
    margin: 0 auto;
    border: 2px solid #fff;
    border-radius: 50%;
    overflow: hidden;
    img {
      width: 100%;
      height: auto;
    }
  }
  .btns {
    width: 80px;
    height: 80px;
    padding-top: 45px;
    border-radius: 50%;
    font-weight: 500;
    text-align: center;
    cursor: pointer;
  }
  // .vr {
  //   position: absolute;
  //   top: 75px;
  //   left: 0;
  //   background: #fff url('../assets/images/icon-360.png') no-repeat center 5px;
  //   background-size: 50% auto;
  // }
  .bobao_cn {
    position: absolute;
    top: 20px;
    left: 0;
    background: #fff url('../assets/images/bobao.png') no-repeat center 5px;
    background-size: 50% auto;
  }
  #playing_cn {
    padding-top: 0 !important;
    position: absolute;
    top: 20px;
    left: 0px;
    background: #fff;
    .icon {
      height: 25px;
      margin-top: 15px;
      margin-bottom: 5px;
    }
  }
  #playing_cn #one {
    // -webkit-animation: yuying1 0.6s infinite 0.1s;
    animation: yuying1 0.6s infinite 0.1s;
  }
  #playing_cn #two {
    // -webkit-animation: yuying1 0.6s infinite 0.3s;
    animation: yuying1 0.6s infinite 0.3s;
  }
  #playing_cn #three {
    // -webkit-animation: yuying1 0.6s infinite 0.5s;
    animation: yuying1 0.6s infinite 0.5s;
  }
  #playing_cn #four {
    // -webkit-animation: yuying1 0.6s infinite 0.7s;
    animation: yuying1 0.6s infinite 0.7s;
  }
  #playing_cn #five {
    // -webkit-animation: yuying1 0.6s infinite 0.9s;
    animation: yuying1 0.6s infinite 0.9s;
  }
  #playing_cn #six {
    // -webkit-animation: yuying1 0.6s infinite 1.1s;
    animation: yuying1 0.6s infinite 1.1s;
  }
  #playing_cn #seven {
    // -webkit-animation: yuying1 0.6s infinite 1.3s;
    animation: yuying1 0.6s infinite 1.3s;
  }
  .bobao_en {
    position: absolute;
    top: 20px;
    right: 0;
    background: #fff url('../assets/images/bobao.png') no-repeat center 5px;
    background-size: 50% auto;
  }
  #playing_en {
    padding-top: 0 !important;
    position: absolute;
    top: 20px;
    right: 0;
    background: #fff;
    .icon {
      height: 25px;
      margin-top: 15px;
      margin-bottom: 5px;
    }
  }
  #playing_en #one {
    // -webkit-animation: yuying1 0.6s infinite 0.1s;
    animation: yuying1 0.6s infinite 0.1s;
  }
  #playing_en #two {
    // -webkit-animation: yuying1 0.6s infinite 0.3s;
    animation: yuying1 0.6s infinite 0.3s;
  }
  #playing_en #three {
    // -webkit-animation: yuying1 0.6s infinite 0.5s;
    animation: yuying1 0.6s infinite 0.5s;
  }
  #playing_en #four {
    // -webkit-animation: yuying1 0.6s infinite 0.7s;
    animation: yuying1 0.6s infinite 0.7s;
  }
  #playing_en #five {
    // -webkit-animation: yuying1 0.6s infinite 0.9s;
    animation: yuying1 0.6s infinite 0.9s;
  }
  #playing_en #six {
    // -webkit-animation: yuying1 0.6s infinite 1.1s;
    animation: yuying1 0.6s infinite 1.1s;
  }
  #playing_en #seven {
    // -webkit-animation: yuying1 0.6s infinite 1.3s;
    animation: yuying1 0.6s infinite 1.3s;
  }
  .wave {
    display: inline-block;
    width: 2px;
    height: 100%;
    margin-left: 3px;
    border-radius: 50px;
    vertical-align: middle;
    background-color: #38a676;
  }
}

.vr-dialog {
  /deep/.el-dialog__header {
    padding: 10px 20px !important;
    background: #fff !important;
  }
}
</style>
